<template>
  <div class="star-rating">
    <img :width="starSize" v-for="n in stars" :key="n" @click="select(n)" src="~../assets/star.svg" alt="">
    <img :width="starSize" v-for="n in (maxStar-stars < 0 ? 0 : maxStar-stars)" :key="stars + n" @click="select(stars + n)" src="~../assets/star_gray.svg" alt="">
  </div>
</template>
<script>

export default {
  model: {
    prop: 'stars',
    event: 'change'
  },
  props: {
    stars: {
      type: Number,
      default: 5
    },
    maxStar: {
      type: Number,
      default: 5
    },
    starSize: {
      type: Number,
      default: 50
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    select (star) {
      if (star !== this.stars && !this.readonly) {
        this.$emit('change', star)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.star-rating{
  display: inline-block;
  font-size: 0;
  vertical-align: middle;
}
</style>
